<template>
  <div>
    <Table border :columns="columns1" :data="data1">
      <template slot-scope="{ row, index }" slot="stiTarget">
        <Input
          type="textarea"
          v-model="row.stiTarget"
          :autosize="true"
          v-if="$store.getters.inputShowData"
          :disabled="inputCheck"
          @on-change="targetItemChange(row, index, 'stiTarget')"
        />
        <span class="textareaHid" v-else>{{ row.stiTarget }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="details" style="width: 100%">
        <Input
          type="textarea"
          v-model="row.details"
          :autosize="true"
          v-if="$store.getters.inputShowData"
          :disabled="inputCheck"
          @on-change="targetItemChange(row, index, 'details')"
        />
        <span class="textareaHid" v-else>{{ row.details }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="startDate">
        <DatePicker
          type="date"
          v-model="row.startDate"
          :transfer="true"
          v-if="$store.getters.inputShowData"
          :disabled="inputCheck"
          :clearable="false"
          @on-change="targetItemChange(row, index, 'startDate')"
        />
        <span class="textareaHid" v-else>{{
          date.dateVal(row.startDate, "YYYY-MM-DD")
        }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="endDate">
        <DatePicker
          type="date"
          v-model="row.endDate"
          :transfer="true"
          v-if="$store.getters.inputShowData"
          :disabled="inputCheck"
          :clearable="false"
          @on-change="targetItemChange(row, index, 'endDate')"
        />
        <span class="textareaHid" v-else>{{
          date.dateVal(row.endDate, "YYYY-MM-DD")
        }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="milepost1">
        <Input
          type="textarea"
          v-model="row.milepost1"
          :autosize="true"
          v-if="$store.getters.inputShowData"
          :disabled="inputCheck"
          @on-change="targetItemChange(row, index, 'milepost1')"
        />
        <span class="textareaHid" v-else>{{ row.milepost1 }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="milepost2">
        <Input
          type="textarea"
          v-model="row.milepost2"
          :autosize="true"
          v-if="$store.getters.inputShowData"
          :disabled="inputCheck"
          @on-change="targetItemChange(row, index, 'milepost2')"
        />
        <span class="textareaHid" v-else>{{ row.milepost2 }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="milepost3">
        <Input
          type="textarea"
          v-model="row.milepost3"
          :disabled="inputCheck"
          v-if="$store.getters.inputShowData"
          :autosize="true"
          @on-change="targetItemChange(row, index, 'milepost3')"
        />
        <span class="textareaHid" v-else>{{ row.milepost3 }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="dataSource">
        <Input
          type="textarea"
          v-model="row.dataSource"
          :disabled="inputCheck"
          v-if="$store.getters.inputShowData"
          :autosize="true"
          @on-change="targetItemChange(row, index, 'dataSource')"
        />
        <span class="textareaHid" v-else>{{ row.dataSource }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="scheduleFollowUp">
        <Input
          type="textarea"
          v-model="row.scheduleFollowUp"
          v-if="$store.getters.inputShowData"
          :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
          :autosize="true"
          @on-change="targetItemChange(row, index, 'scheduleFollowUp')"
        />
        <span class="textareaHid" v-else>{{ row.scheduleFollowUp }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="reachRatio">
        <Select
          v-model="row.reachRatio"
          @on-change="targetItemChange(row, index, 'reachRatio')"
          :transfer="true"
          :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
        >
          <Option
            v-for="item in STIProportion"
            :value="item.code"
            :key="item.code"
            >{{ item.ch_value }}</Option
          >
        </Select>
        <!-- <Input type="textarea" v-model="row.midText1" :autosize="true" /> -->
      </template>
      <template slot-scope="{ row, index }" slot="indirSupFeedback">
        <Input
          type="textarea"
          v-model="row.indirSupFeedback"
          :autosize="true"
          :disabled="
            applyEditFlag == '1' || (userDeptFlag != '3' && userDeptFlag != '4')
          "
          @on-change="targetItemChange(row, index, 'indirSupFeedback')"
        />
      </template>
      <template slot-scope="{ row, index }" slot="dirSupFeedback">
        <div v-if="$store.getters.inputShowData">
          <Input
            type="textarea"
            v-model="row.dirSupFeedback"
            :autosize="true"
            v-if="tabName != 'STICom'"
            :disabled="
              applyEditFlag == '1' ||
                (userDeptFlag != '2' && userDeptFlag != '4')
            "
            @on-change="targetItemChange(row, index, 'dirSupFeedback')"
          />
          <Input
            type="textarea"
            v-model="row.dirSupFeedback"
            :autosize="true"
            v-else
            :disabled="
              beApprovalFlag != '2' ||
                (userDeptFlag != '2' && userDeptFlag != '4')
            "
            @on-change="targetItemChange(row, index, 'dirSupFeedback')"
          />
        </div>
        <span class="textareaHid" v-else>{{ row.dirSupFeedback }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="attachment">
        <div style="display:flex;flex-wrap:wrap">
          <Upload
            :action="action"
            :show-upload-list="false"
            :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
            :max-size="10240"
            :on-exceeded-size = "ErrorUpload"
            :on-success="
              (response, file, fileList) =>
                uploadFiled(response, file, fileList, row, index)
            "
            :on-error="handleUpload"
          >
            <Icon
              type="ios-create"
              style="font-size: 30px"
              :color="
                applyEditFlag != '1' && userDeptFlag == '1'
                  ? '#8CD29B'
                  : '#cccccc'
              "
              @click="editSTI(row, index)"
            ></Icon>
          </Upload>
          <span
            style="width: 80%;word-break: normal; display: block; white-space: pre-wrap;overflow: hidden;"
            >{{ row.attachmentName }}</span
          >
          <Icon
            v-if="
              row.attachmentName && applyEditFlag != '1' && userDeptFlag == '1'
                ? true
                : false
            "
            type="md-trash"
            style="color: red"
            @click="clearFiled(row, index)"
          />
          <Icon
            style="font-size: 22px"
            v-if="row.attachmentName"
            type="md-cloud-download"
            color="#8CD29B"
            @click="download(row, index)"
          />
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="finishDataSource">
        <Input
          type="textarea"
          v-model="row.finishDataSource"
          :autosize="true"
          v-if="$store.getters.inputShowData"
          :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
          @on-change="targetItemChange(row, index, 'finishDataSource')"
        />
        <span class="textareaHid" v-else>{{ row.finishDataSource }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="specialAdjust">
        <div style="display: flex; align-items: center">
          <Checkbox
            v-model="row.single"
            :disabled="specialFlag != '1'"
          ></Checkbox>
          <Select
            :disabled="!row.single || specialFlag != '1'"
            :transfer="true"
            v-model="row.specialAdjust"
            @on-change="targetItemChange(row, index, 'specialAdjust')"
          >
            <Option
              v-for="item in STIProportion"
              :value="item.code"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="specialAttachment">
        <div style="display:flex;flex-wrap:wrap">
          <Upload
            :action="action"
            :show-upload-list="false"
            :disabled="specialFlag != '1'"
            :on-success="
              (response, file, fileList) =>
                uploadFiled1(response, file, fileList, row, index)
            "
            :on-error="handleUpload"
            :max-size="10240"
            :on-exceeded-size = "ErrorUpload"
          >
            <Icon
              type="ios-create"
              style="font-size: 30px"
              :color="specialFlag == '1' ? '#8CD29B' : '#cccccc'"
              @click="editSTI(row, index)"
            ></Icon>
          </Upload>
          <span
            style="width: 80%;word-break: normal; display: block; white-space: pre-wrap;overflow: hidden;"
            >{{ row.specialAttachmentName }}</span
          >
          <Icon
            v-if="
              row.specialAttachmentName && specialFlag == '1' ? true : false
            "
            type="md-trash"
            style="color: red"
            @click="clearFiled1(row, index)"
          />
          <Icon
            style="font-size: 22px"
            v-if="row.specialAttachmentName"
            type="md-cloud-download"
            color="#8CD29B"
            @click="download1(row, index)"
          />
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="specialComment">
        <Input
          type="textarea"
          v-model="row.specialComment"
          :autosize="true"
          v-if="$store.getters.inputShowData"
          :disabled="specialFlag != '1'"
          @on-change="targetItemChange(row, index, 'specialComment')"
        />
        <span class="textareaHid" v-else>{{ row.specialComment }}</span>
      </template>
      <template slot-scope="{ row }" slot="status">
        <span style="color:red" v-if="row.status == '新增'"
          ><!-- 新增 -->{{ $t("Add") }}</span
        >
        <span style="color:red" v-if="row.status == '删除'"
          ><!-- 删除 -->{{ $t("Delete") }}</span
        >
        <span style="color:red" v-if="row.status == '编辑'"
          ><!-- 编辑 -->{{ $t("Edit") }}</span
        >
      </template>
      <template slot-scope="{ row, index }" slot="action12">
        <Button
          icon="md-trash"
          type="warning"
          size="small"
          v-if="targetRevisionState"
          :disabled="applyEditFlag == '1'"
          @click="deleteSTI(row, index)"
        ></Button>
        <Button
          icon="md-trash"
          type="warning"
          size="small"
          v-else
          :disabled="row.id ? true : false"
          @click="deleteSTI(row, index)"
        ></Button>
      </template>
    </Table>
    <div
      style="display: flex; justify-content: flex-end; margin-top: 10px"
      v-if="tabName == 'goalSetting'"
    >
      <Button
        style="margin-right: 15px"
        @click="selectPlan"
        :disabled="applyEditFlag == '1'"
        >{{ $t("Select_Target") }}</Button
      >
      <Button
        @click="addSTI()"
        :disabled="applyEditFlag == '1' && targetRevisionState"
        ><!-- 新增 -->{{ $t("Add") }}</Button
      >
    </div>

    <Modal v-model="modalShow" :title="$t('Select_STI')" width="80%">
      <Table
        border
        ref="selection"
        :loading="columnsLoading"
        :columns="columnsModal"
        :data="dataModal"
        @on-selection-change="itemClick"
      ></Table>
      <div slot="footer">
        <Button @click="modalSave"><!-- 确认 -->{{ $t("Confirm") }}</Button>
        <Button @click="modalShow = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import DateUtil from "@/util/DateUtil";
import axios from "axios";
export default {
  props: ["tabName"],
  data() {
    return {
      date: new DateUtil(),
      columns1: [],
      status: "",
      applyEditFlag: "",
      userDeptFlag: "",
      data1: [],
      spanb: [],
      sid: 0,
      action: "/api/resource/upload",
      STIProportion: [],
      modalShow: false,
      columnsModal: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "STI",
          key: "stiTarget",
          ellipsis: true
        },
        {
          title: this.$t("Share_Name"),
          key: "sharerName"
        },
        {
          title: this.$t("Share_Date"),
          key: "createTime",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.createTime, "YYYY-MM-DD HH:mm")
            );
          }
        }
      ],
      dataModal: [],
      targetIdList: [],
      targetRevisionState: true,
      columnsLoading: false,
      oldData: [],
      specialFlag: "",
      beApprovalFlag: "",
      specialDisPlayFlag: ""
    };
  },
  created() {
    this.getMidData();
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (this.tabName == "midTermReview") {
        this.getMidData();
        // this.columns1 = this.midSTIColumns;
      } else if (this.tabName == "yearEndSummary") {
        this.getMidData();
        // this.columns1 = this.yearSTIColumns;
      } else if (this.tabName == "STICom") {
        if (this.specialDisPlayFlag == "1" || this.specialFlag == "1") {
          this.columns1 = [...this.STIUColumns, ...this.SITUPColumns];
        } else {
          this.columns1 = [...this.STIUColumns];
        }
      } else {
        this.columns1 = this.goalSTIColumns;
        this.$emit("onInter");
      }
    },
    targetRevisionState(newVal, oldVal) {
      this.targetRevisionState = newVal;
    }
  },
  computed: {
    inputCheck() {
      let value = true;
      if (this.tabName != "goalSetting" && this.tabName != "SITUpdate") {
        value = true;
      } else {
        if (
          (this.applyEditFlag == "1" || this.userDeptFlag != "1") &&
          this.targetRevisionState
        )
          value = true;
        else value = false;
      }
      return value;
    },
    goalSTIColumns() {
      return [
        {
          title: /* "STI个人目标" */ this.$t("STI_Self"),
          slot: "stiTarget",
          minWidth: 160,
          align: "center",
          ellipsis: true
        },
        {
          title: /* "详细描述" */ this.$t("Detailed_Description"),
          slot: "details",
          align: "center",
          minWidth: 200,
          ellipsis: true
        },
        {
          title: /* "开始日期" */ this.$t("Start_Date"),
          slot: "startDate",
          align: "center",
          minWidth: 160
        },
        {
          title: /* "结束日期" */ this.$t("End_Date"),
          slot: "endDate",
          align: "center",
          minWidth: 160
        },
        {
          title: /* "里程碑1" */ this.$t("Milestone1"),
          slot: "milepost1",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "里程碑2" */ this.$t("Milestone2"),
          slot: "milepost2",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "里程碑3" */ this.$t("Milestone3"),
          slot: "milepost3",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "数据来源" */ this.$t("Data_Source"),
          slot: "dataSource",
          align: "center",
          minWidth: 220,
          ellipsis: true
        },
        {
          title: /* "删除" */ this.$t("Delete"),
          slot: "action12",
          align: "center",
          minWidth: 80
        }
      ];
    },
    midSTIColumns() {
      return [
        {
          title: /* "STI个人目标" */ this.$t("STI_Self"),
          slot: "stiTarget",
          minWidth: 160,
          align: "center",
          ellipsis: true
        },
        {
          title: /* "里程碑1" */ this.$t("Milestone1"),
          slot: "milepost1",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "里程碑2" */ this.$t("Milestone2"),
          slot: "milepost2",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "里程碑3" */ this.$t("Milestone3"),
          slot: "milepost3",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: this.$t("longText34") /* 进度说明及后期回顾 */,
          slot: "scheduleFollowUp",
          align: "center",
          minWidth: 200,
          ellipsis: true
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 虚线上级反馈 */,
          slot: "indirSupFeedback",
          align: "center",
          minWidth: 150,
          maxWidth: 150,
          ellipsis: true
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          slot: "dirSupFeedback",
          align: "center",
          minWidth: 225,
          maxWidth: 225,
          ellipsis: true
        }
      ];
    },
    yearSTIColumns() {
      return [
        {
          title: /* "STI个人目标" */ this.$t("STI_Self"),
          slot: "stiTarget",
          minWidth: 160,
          align: "center",
          ellipsis: true
        },
        {
          title: /* "里程碑1" */ this.$t("Milestone1"),
          slot: "milepost1",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "里程碑2" */ this.$t("Milestone2"),
          slot: "milepost2",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "里程碑3" */ this.$t("Milestone3"),
          slot: "milepost3",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "开始日期" */ this.$t("Start_Date"),
          slot: "startDate",
          align: "center",
          minWidth: 160
        },
        {
          title: /* "结束日期" */ this.$t("End_Date"),
          slot: "endDate",
          align: "center",
          minWidth: 160
        },
        {
          title: /* "达成比例" */ this.$t("Milestones_Obtained"),
          slot: "reachRatio",
          align: "center",
          minWidth: 110,
          ellipsis: true
        },
        {
          title: /* "实际完成情况及数据来源" */ this.$t(
            "Completion_Status_&_Data_Source"
          ),
          slot: "finishDataSource",
          align: "center",
          minWidth: 200,
          ellipsis: true
        },
        {
          title: /* "附件" */ this.$t("Attachment"),
          slot: "attachment",
          align: "center",
          minWidth: 80,
          ellipsis: true
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 虚线上级反馈 */,
          slot: "indirSupFeedback",
          align: "center",
          minWidth: 150,
          maxWidth: 150,
          ellipsis: true,
          hidden: true
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          slot: "dirSupFeedback",
          align: "center",
          minWidth: 225,
          maxWidth: 225,
          ellipsis: true,
          hidden: true
        }
      ];
    },
    STIUColumns() {
      return [
        {
          title: /* "STI个人目标" */ this.$t("STI_Self"),
          slot: "stiTarget",
          minWidth: 160,
          align: "center",
          ellipsis: true
        },
        {
          title: /* "里程碑1" */ this.$t("Milestone1"),
          slot: "milepost1",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "里程碑2" */ this.$t("Milestone2"),
          slot: "milepost2",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "里程碑3" */ this.$t("Milestone3"),
          slot: "milepost3",
          align: "center",
          minWidth: 160,
          ellipsis: true
        },
        {
          title: /* "开始日期" */ this.$t("Start_Date"),
          slot: "startDate",
          align: "center",
          minWidth: 160
        },
        {
          title: /* "结束日期" */ this.$t("End_Date"),
          slot: "endDate",
          align: "center",
          minWidth: 160
        },
        {
          title: /* "达成比例" */ this.$t("Milestones_Obtained"),
          slot: "reachRatio",
          align: "center",
          minWidth: 200,
          ellipsis: true
        },
        {
          title: /* "实际完成情况及数据来源" */ this.$t(
            "Completion_Status_&_Data_Source"
          ),
          slot: "finishDataSource",
          align: "center",
          minWidth: 200,
          ellipsis: true
        },
        {
          title: /* "附件" */ this.$t("Attachment"),
          slot: "attachment",
          align: "center",
          minWidth: 80,
          ellipsis: true
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          slot: "dirSupFeedback",
          align: "center",
          minWidth: 225,
          maxWidth: 225,
          ellipsis: true,
          hidden: true
        }
      ];
    },
    SITUPColumns() {
      return [
        {
          title: /* "特殊调整" */ this.$t("Adjust_To"),
          slot: "specialAdjust",
          align: "center",
          minWidth: 200,
          ellipsis: true
        },
        {
          title: /* "附件" */ this.$t("Attachment"),
          slot: "specialAttachment",
          align: "center",
          minWidth: 180,
          ellipsis: false
        },
        {
          title: /* "备注" */ this.$t("Remarks"),
          slot: "specialComment",
          align: "center",
          minWidth: 200,
          ellipsis: true
        }
      ];
    }
  },
  methods: {
    getMidData() {
      if (this.tabName == "yearEndSummary") {
        if (this.userDeptFlag == "1") {
          if (this.status < 5) {
            this.columns1 = this.yearSTIColumns.filter(function(e) {
              return !e.hidden;
            });
          } else {
            this.columns1 = this.yearSTIColumns;
          }
        } else {
          this.columns1 = this.yearSTIColumns;
        }
      } else if (this.tabName == "midTermReview") {
        this.columns1 = this.midSTIColumns;
      } else if (this.tabName == "STICom") {
        if (this.specialDisPlayFlag == "1" || this.specialFlag == "1") {
          this.columns1 = [...this.STIUColumns, ...this.SITUPColumns];
        } else {
          this.columns1 = [...this.STIUColumns];
        }
      } else {
        this.columns1 = this.goalSTIColumns;
      }
      axios.post("/achApply/selectApplyAchLabel", {}).then(res => {
        if (res) {
          this.STIProportion = res.STIProportion;
        }
      });
    },
    addSTI() {
      // if(this.data1.length>=2){
      //   this.$Message.info(this.$t('已经存在两条STI个人目标，无法新增'))
      //   return
      // }
      this.sid++;
      if (!this.targetRevisionState) {
        this.data1.push({
          stiTarget: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31",
          dataSource: "",
          milepost1: "",
          milepost2: "",
          milepost3: "",
          // milepostInput: "",
          sid: this.sid,
          status: "新增"
        });
        this.oldData.push({
          stiTarget: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31",
          dataSource: "",
          milepost1: "",
          milepost2: "",
          milepost3: "",
          // milepostInput: "",
          sid: this.sid,
          status: "新增"
        });
      } else {
        this.data1.push({
          stiTarget: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31",
          dataSource: "",
          milepost1: "",
          milepost2: "",
          milepost3: "",
          // milepostInput: "",
          sid: this.sid
        });
      }
    },
    ErrorUpload(){
      this.$Message.error("文件大小不允许超过10M")
    },
    editSTI(row, index) {},
    deleteSTI(row, i) {
      if (row.status == "删除") {
        return;
      }
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        onOk: () => {
          if (
            !this.targetRevisionState &&
            (row.status == "" || row.status == "编辑")
          ) {
            row.status = "删除";
            this.$set(this.data1[i], "status", "删除");
          } else {
            this.data1.splice(i, 1);
            this.oldData.splice(i, 1);
          }
          // this.data1.splice(i,1)
          // this.oldData.splice(i,1)
        }
      });
    },
    targetItemChange(row, index, key) {
      key == "stiTarget"
        ? this.$set(this.data1[index], "stiTarget", row.stiTarget)
        : "";
      key == "details"
        ? this.$set(this.data1[index], "details", row.details)
        : "";
      key == "startDate"
        ? this.$set(
            this.data1[index],
            "startDate",
            this.date.dateVal(row.startDate, "YYYY-MM-DD")
          )
        : "";
      key == "endDate"
        ? this.$set(
            this.data1[index],
            "endDate",
            this.date.dateVal(row.endDate, "YYYY-MM-DD")
          )
        : "";
      key == "milepost1"
        ? this.$set(this.data1[index], "milepost1", row.milepost1)
        : "";
      key == "milepost2"
        ? this.$set(this.data1[index], "milepost2", row.milepost2)
        : "";
      key == "milepost3"
        ? this.$set(this.data1[index], "milepost3", row.milepost3)
        : "";
      key == "dataSource"
        ? this.$set(this.data1[index], "dataSource", row.dataSource)
        : "";
      key == "scheduleFollowUp"
        ? this.$set(this.data1[index], "scheduleFollowUp", row.scheduleFollowUp)
        : "";
      key == "indirSupFeedback" 
        ? this.$set(this.data1[index], "indirSupFeedback", row.indirSupFeedback)
        : "";
      key == "dirSupFeedback"
        ? this.$set(this.data1[index], "dirSupFeedback", row.dirSupFeedback)
        : "";
      key == "reachRatio"
        ? this.$set(this.data1[index], "reachRatio", row.reachRatio)
        : "";

      key == "finishDataSource"
        ? this.$set(this.data1[index], "finishDataSource", row.finishDataSource)
        : "";
      key == "attachment"
        ? this.$set(this.data1[index], "attachment", row.attachment)
        : "";
      key == "specialAdjust"
        ? this.$set(this.data1[index], "specialAdjust", row.specialAdjust)
        : "";
      key == "specialAdjust"
        ? this.$set(this.data1[index], "single", row.single)
        : "";
      key == "specialAttachment"
        ? this.$set(
            this.data1[index],
            "specialAttachment",
            row.specialAttachment
          )
        : "";
      key == "specialComment"
        ? this.$set(this.data1[index], "specialComment", row.specialComment)
        : "";
      key == "startDate"
        ? this.$set(
            this.oldData[index],
            "startDate",
            this.date.dateVal(this.oldData[index].startDate, "YYYY-MM-DD")
          )
        : "";
      key == "endDate"
        ? this.$set(
            this.oldData[index],
            "endDate",
            this.date.dateVal(this.oldData[index].endDate, "YYYY-MM-DD")
          )
        : "";

      if (
        JSON.stringify(this.oldData[index]) !=
          JSON.stringify(this.data1[index]) &&
        !this.targetRevisionState
      ) {
        if (row.status != "新增" && row.status != "删除") {
          /* && row.status!='删除' */
          this.$set(this.data1[index], "status", "编辑");
          this.$set(this.oldData[index], "status", "编辑");
        }
      } else if (!this.targetRevisionState) {
        this.$set(this.data1[index], "status", "");
        this.$set(this.oldData[index], "status", "");
      }
    },
    uploadFiled(response, file, fileList, row, index) {
      this.$set(this.data1[index], "attachmentName", file.name);
      this.$set(this.data1[index], "attachment", response.data);
    },
    uploadFiled1(response, file, fileList, row, index) {
      this.$set(this.data1[index], "specialAttachmentName", file.name);
      this.$set(this.data1[index], "specialAttachment", response.data);
    },
    clearFiled(row, index) {
      this.$set(this.data1[index], "attachmentName", "");
      this.$set(this.data1[index], "attachment", "");
    },
    clearFiled1(row, index) {
      this.$set(this.data1[index], "specialAttachmentName", "");
      this.$set(this.data1[index], "specialAttachment", "");
    },
    handleUpload(error) {},
    selectPlan() {
      this.modalShow = true;
      let obj = {
        shared: JSON.parse(sessionStorage.getItem("userInfo")).serialnumber,
        targetType: "STI个人目标"
      };
      this.columnsLoading = true;
      axios.post("/achTargetShare/selectTargetShareInfo", obj).then(res => {
        this.columnsLoading = false;
        if (res) {
          this.dataModal = res;
        }
      });
    },
    itemClick(item) {
      this.targetIdList = item;
    },
    modalSave() {
      let list = [];
      this.targetIdList.map((item, index) => {
        var obj = {
          targetId: item.targetId
        };
        list.push(obj);
      });
      axios.post("/achTargetShare/selectAchStiTargetInfo", list).then(res => {
        if (res) {
          let array = res;
          array.forEach((item, index) => {
            if (index === 0) {
              item.sid = this.sid++;
              this.data1.push(item);
            } else {
              if (item.targetId === array[index - 1].targetId) {
                item.sid = array[index - 1].sid;
                this.data1.push(item);
              } else {
                item.sid = this.sid++;
                this.data1.push(item);
              }
            }
          });
          this.modalShow = false;
        }
      });
    },
    download(row) {
      this.$donwLoad(row.attachment);
    },
    download1(row) {
      this.$donwLoad(row.specialAttachment);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ivu-table-header table thead tr:nth-child(2) {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/STIComponent.vue